import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import ILinha from '@model/Linha';
import { IConsumoInternetRecord, useRelatorioService } from '@services/RelatorioService';
import React from 'react';
import { ConsumoInternetDetalhesTable } from './ConsumoInternetHistoricoTable';

export type ConsumoInternetDetalhesModalProps = {
    linha: ILinha
    competencia: string
    modal: IModalWindow
}

export function ConsumoInternetDetalhesModal ({ linha, competencia, modal }: ConsumoInternetDetalhesModalProps) {
    const formatter = useFormatter();
    const loading = useLoading();
    const message = useMessage();

    const data = useData<IConsumoInternetRecord>();

    const relatorioService = useRelatorioService();
    
    const handleEnter = React.useCallback(() => {
        data.clear();

        if (!loading.isLoading) {
            loading.start();
            relatorioService.listarConsumoInternetHistorico(linha.linhaId, competencia)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [competencia, data, linha.linhaId, loading, message.showException, relatorioService]);

    return (
        <ModalWindow
            modal={modal}
            size="md"
            disabled={loading.isLoading}
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Histórico de Consumo de Internet da Linha ${formatter.toCelular(linha.numeroSemMascara)} (${linha.linhaId})`}
            />
            
            <ModalWindowContent>
                <ConsumoInternetDetalhesTable 
                    data={data}
                />
            </ModalWindowContent>
        </ModalWindow>
    )
}